import React from "react"
import BifrostButton from "../../../BifrostElementComponent/BifrostButton/BifrostButton"

const BifrostConfirmModalActions = ({ isError, errorHandler, loading, confirmButtonColor, confirmText, confirmHandler, cancelHandler }) => {
	return (
		<>
			{isError ? (
				<BifrostButton style={{ display: "inline-block" }} color="gray" disabled={loading} onClick={errorHandler}>
					OK
				</BifrostButton>
			) : (
				<>
					<BifrostButton style={{ display: "inline-block" }} color={confirmButtonColor ? confirmButtonColor : "red"} disabled={loading} onClick={confirmHandler}>
						{confirmText ? confirmText : "Delete"}
					</BifrostButton>
					<BifrostButton style={{ display: "inline-block" }} color="gray" disabled={loading} onClick={cancelHandler}>
						Cancel
					</BifrostButton>
				</>
			)}
		</>
	)
}
export default BifrostConfirmModalActions
